'use client';

import Link from 'next/link';
import { useEffect } from 'react';

export default function SeriesError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  const isChunkError = error?.name === 'ChunkLoadError' || error?.message?.includes('Failed to load chunk');

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4" dir="rtl">
      <h1 className="text-xl font-bold mt-6">مشکلی پیش آمد</h1>
      <p className="text-gray-500 mt-2 text-sm">
        {isChunkError ? 'لطفاً صفحه را بارگذاری مجدد کنید.' : 'در دریافت اطلاعات سریال مشکلی رخ داد.'}
      </p>
      <div className="flex gap-3 mt-6">
        <button
          onClick={() => isChunkError ? window.location.reload() : reset()}
          className="inline-block bg-primary hover:bg-primary-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors"
        >
          تلاش مجدد
        </button>
        <Link
          href="/"
          className="inline-block border border-white/20 hover:border-white/40 text-white font-semibold py-2 px-6 rounded-lg transition-colors"
        >
          بازگشت به خانه
        </Link>
      </div>
    </div>
  );
}
